import { createApiAction } from 'src/api';
import dayjs from 'dayjs-ext';
import { DEFAULT_DATE_FORMAT } from '../../../../ui/const';

export const ADD_LOCATION_START = 'account/add_location_start';
export const ADD_LOCATION_SUCCESS = 'account/add_location_success';
export const ADD_LOCATION_FAILURE = 'account/add_location_failure';

export const SET_LOCATION_LICENSE_IMAGES_START =
  'account/set_location_license_images_start';
export const SET_LOCATION_LICENSE_IMAGES_SUCCESS =
  'account/set_location_license_images_success';
export const SET_LOCATION_LICENSE_IMAGES_FAILURE =
  'account/set_location_license_images_failure';

export const UPDATE_LOCATION_START = 'account/update_location_start';
export const UPDATE_LOCATION_SUCCESS = 'account/update_location_success';
export const UPDATE_LOCATION_FAILURE = 'account/update_location_failure';

export const DELETE_LOCATION_START = 'account/delete_location_start';
export const DELETE_LOCATION_SUCCESS = 'account/delete_location_success';
export const DELETE_LOCATION_FAILURE = 'account/delete_location_failure';

const processLocation = loc => {
  const result = {};

  // Only include fields that are actually present (for partial updates)
  if (loc.addressType?.id) result.location_address_type = loc.addressType.id;
  if (loc.address) result.location_address = loc.address;
  if (loc.address2) result.location_address_2 = loc.address2;
  if (loc.city) result.location_city = loc.city;
  if (loc.state?.value) result.location_state = loc.state.value;
  if (loc.zipCode) result.location_zipcode = loc.zipCode.replace(/\D/g, '');
  if (loc.licenseType?.id !== undefined) result.location_license_type = loc.licenseType.id;
  if (loc.licenseNumber) result.location_license_number = loc.licenseNumber;
  if (loc.licenseDateIssued) result.location_license_date_issued = dayjs(loc.licenseDateIssued).format(DEFAULT_DATE_FORMAT);
  if (loc.licenseDateExpired) result.location_license_date_expired = dayjs(loc.licenseDateExpired).format(DEFAULT_DATE_FORMAT);
  if (loc.phoneNumber) result.location_phone_number = loc.phoneNumber;
  if (loc.customerServicePhoneNumber) result.location_customer_service_number = loc.customerServicePhoneNumber;
  if (loc.dba) result.location_dba = loc.dba;
  if (loc.email) result.location_email = loc.email;
  if (loc.facebook) result.location_facebook = loc.facebook;
  if (loc.linkedin) result.location_linkedin = loc.linkedin;
  if (loc.twitter) result.location_twitter = loc.twitter;
  if (loc.instagram) result.location_instagram = loc.instagram;
  if (loc.licenseCheckToggle !== undefined) result.location_license_check = loc.licenseCheckToggle;
  if (loc.licenseURL) result.location_license_url = loc.licenseURL;
  if (loc.consentURL) result.location_consent_url = loc.consentURL;
  if (loc.apiKey) {
    result._location_regulatory_api_key_enc = loc.apiKey;
    result.location_regulatory_api_key = loc.apiKey;
  }

  // Always include location_notes if present (for our notes update)
  if (loc.location_notes !== undefined) result.location_notes = loc.location_notes;

  // Handle image deletions - need to explicitly send null
  if ('location_license_image_front' in loc) {
    result.location_license_image_front = loc.location_license_image_front;
  }
  if ('location_license_image_back' in loc) {
    result.location_license_image_back = loc.location_license_image_back;
  }

  return result;
};

export const addAccountLocation = ({ accountId, ...location }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/locations/`,
      method: 'POST',
      body: processLocation(location),
    },
    [ADD_LOCATION_START, ADD_LOCATION_SUCCESS, ADD_LOCATION_FAILURE]
  );

export const updateAccountLocation = ({ accountId, locationId, ...location }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/locations/${locationId}/`,
      method: 'PUT',
      body: processLocation(location),
    },
    [UPDATE_LOCATION_START, UPDATE_LOCATION_SUCCESS, UPDATE_LOCATION_FAILURE]
  );

export const setLocationLicenseImages = ({
  accountId,
  locationId,
  imageFront,
  imageBack,
}) => {
  const formData = new FormData();

  if (imageFront) {
    formData.append('location_license_image_front', imageFront);
  }

  if (imageBack) {
    formData.append('location_license_image_back', imageBack);
  }

  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/locations/${locationId}/license_images/`,
      method: 'POST',
      formData,
    },
    [
      SET_LOCATION_LICENSE_IMAGES_START,
      SET_LOCATION_LICENSE_IMAGES_SUCCESS,
      SET_LOCATION_LICENSE_IMAGES_FAILURE,
    ]
  );
};

export const deleteAccountLocation = ({ accountId, locationId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/locations/${locationId}/`,
      method: 'DELETE',
    },
    [DELETE_LOCATION_START, DELETE_LOCATION_SUCCESS, DELETE_LOCATION_FAILURE]
  );
};
